export default __webpack_public_path__ + "static/media/bazzle_m_3.cb4882ca.png";